function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import locationHook from "./use-location.js";
import makeMatcher from "./matcher.js";
import { useRef, useLayoutEffect, useContext, useCallback, createContext, isValidElement, cloneElement, createElement as h, Fragment } from "./react-deps.js";

/*
 * Part 1, Hooks API: useRouter, useRoute and useLocation
 */

// one of the coolest features of `createContext`:
// when no value is provided — default object is used.
// allows us to use the router context as a global ref to store
// the implicitly created router (see `useRouter` below)
var RouterCtx = createContext({});
var buildRouter = function buildRouter() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref$hook = _ref.hook,
    hook = _ref$hook === void 0 ? locationHook : _ref$hook,
    _ref$base = _ref.base,
    base = _ref$base === void 0 ? "" : _ref$base,
    _ref$matcher = _ref.matcher,
    matcher = _ref$matcher === void 0 ? makeMatcher() : _ref$matcher;
  return {
    hook: hook,
    base: base,
    matcher: matcher
  };
};
export var useRouter = function useRouter() {
  var globalRef = useContext(RouterCtx);

  // either obtain the router from the outer context (provided by the
  // `<Router /> component) or create an implicit one on demand.
  return globalRef.v || (globalRef.v = buildRouter());
};
export var useLocation = function useLocation() {
  var router = useRouter();
  return router.hook(router);
};
export var useRoute = function useRoute(pattern) {
  var _useLocation = useLocation(),
    _useLocation2 = _slicedToArray(_useLocation, 1),
    path = _useLocation2[0];
  return useRouter().matcher(pattern, path);
};

// internal hook used by Link and Redirect in order to perform navigation
var useNavigate = function useNavigate(options) {
  var navRef = useRef();
  var _useLocation3 = useLocation(),
    _useLocation4 = _slicedToArray(_useLocation3, 2),
    navigate = _useLocation4[1];
  navRef.current = function () {
    return navigate(options.to || options.href, options);
  };
  return navRef;
};

/*
 * Part 2, Low Carb Router API: Router, Route, Link, Switch
 */

export var Router = function Router(props) {
  var ref = useRef();

  // this little trick allows to avoid having unnecessary
  // calls to potentially expensive `buildRouter` method.
  // https://reactjs.org/docs/hooks-faq.html#how-to-create-expensive-objects-lazily
  var value = ref.current || (ref.current = {
    v: buildRouter(props)
  });
  return h(RouterCtx.Provider, {
    value: value,
    children: props.children
  });
};
export var Route = function Route(_ref2) {
  var path = _ref2.path,
    match = _ref2.match,
    component = _ref2.component,
    children = _ref2.children;
  var useRouteMatch = useRoute(path);

  // `props.match` is present - Route is controlled by the Switch
  var _ref3 = match || useRouteMatch,
    _ref4 = _slicedToArray(_ref3, 2),
    matches = _ref4[0],
    params = _ref4[1];
  if (!matches) return null;

  // React-Router style `component` prop
  if (component) return h(component, {
    params: params
  });

  // support render prop or plain children
  return typeof children === "function" ? children(params) : children;
};
export var Link = function Link(props) {
  var navRef = useNavigate(props);
  var _useRouter = useRouter(),
    base = _useRouter.base;
  var to = props.to,
    _props$href = props.href,
    href = _props$href === void 0 ? to : _props$href,
    children = props.children,
    onClick = props.onClick;
  var handleClick = useCallback(function (event) {
    // ignores the navigation when clicked using right mouse button or
    // by holding a special modifier key: ctrl, command, win, alt, shift
    if (event.ctrlKey || event.metaKey || event.altKey || event.shiftKey || event.button !== 0) return;
    event.preventDefault();
    navRef.current();
    onClick && onClick(event);
  },
  // navRef is a ref so it never changes
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [onClick]);

  // wraps children in `a` if needed
  var extraProps = {
    // handle nested routers and absolute paths
    href: href[0] === "~" ? href.slice(1) : base + href,
    onClick: handleClick,
    to: null
  };
  var jsx = isValidElement(children) ? children : h("a", props);
  return cloneElement(jsx, extraProps);
};
var flattenChildren = function flattenChildren(children) {
  var _ref5;
  return Array.isArray(children) ? (_ref5 = []).concat.apply(_ref5, _toConsumableArray(children.map(function (c) {
    return c && c.type === Fragment ? flattenChildren(c.props.children) : flattenChildren(c);
  }))) : [children];
};
export var Switch = function Switch(_ref6) {
  var children = _ref6.children,
    location = _ref6.location;
  var _useRouter2 = useRouter(),
    matcher = _useRouter2.matcher;
  var _useLocation5 = useLocation(),
    _useLocation6 = _slicedToArray(_useLocation5, 1),
    originalLocation = _useLocation6[0];
  var _iterator = _createForOfIteratorHelper(flattenChildren(children)),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var element = _step.value;
      var match = 0;
      if (isValidElement(element) &&
      // we don't require an element to be of type Route,
      // but we do require it to contain a truthy `path` prop.
      // this allows to use different components that wrap Route
      // inside of a switch, for example <AnimatedRoute />.
      (match = element.props.path ? matcher(element.props.path, location || originalLocation) : [true, {}])[0]) return cloneElement(element, {
        match: match
      });
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return null;
};
export var Redirect = function Redirect(props) {
  var navRef = useNavigate(props);

  // empty array means running the effect once, navRef is a ref so it never changes
  useLayoutEffect(function () {
    navRef.current();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return null;
};
export default useRoute;